// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 28) return "static/js/63e5e299d5014ba2453a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"9db196dea8515d6fed71","150":"9ab7fff278003abd7181","151":"00db1e221a9f839e2a80"}[chunkId] + ".chunk.js";
};